import React from 'react';
import ReactDOM from 'react-dom';
import App from './src/App.js';

const app = document.querySelector('#trust-object-profile-podlet');
// const props = app.dataset;
const dataElement = document.getElementById('trust-object-profile-podlet-data');
const initalState = JSON.parse(dataElement.textContent);

ReactDOM.hydrate(<App {...initalState} />, app);
